import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { Website } from "./components/website";
import { Tournament } from "./components/tournament";
import { School } from "./components/school";


function App() {
  return(
    <HashRouter>
    <Routes>
    {/* <Route path="/" exact element={<Navigate to="/muthoot_finance/1" />} /> */}
    {/* <Route path="/:fun/:id" exact={true} element={<School />} /> */}
    <Route path="/:fun/:id" exact={true} element={<Website />} />

    <Route path="/fundertournamentdetails/:fun/:id" element={<Tournament />} />
    <Route path="/externaltournamentdetails/:fun/:id" element={<Tournament />} />

    <Route path="/fundereventdetails/:fun/:id" element={<Tournament />} />
    <Route path="/eventdetails/:fun/:id" element={<Tournament />} />

    <Route path="/tournamentdetails/:fun/:id" element={<Tournament />} />


    </Routes>
  </HashRouter>
  )
}

export default App;
